module.exports = __webpack_public_path__ + "static/assets/8780858934fbece30db4c564cec4e473.svg";